module.exports = __webpack_public_path__ + "img/creditcard.e89b6b4c.svg";